export default "__VITE_ASSET__DFqXb3CV__"